import { Alert } from '@mui/material';

import AsyncStatus from '../../../Lib/UI/Components/AsyncStatus';
import CustomList from '../../../Lib/UI/Components/CustomList';
import useRecentPlacesList, { RecentPlacesListProps } from '../hooks/useRecentPlacesList';
import SearchPlacesListItem from './searchPlacesListItem';


const RecentPlacesList = (props: RecentPlacesListProps): JSX.Element => {

    const list = useRecentPlacesList(props);

    return (
        <AsyncStatus action={list.loadStatus} showChildrenWhenComplete={true} busyLabel="Loading..." >

            {!list.hasResults && <Alert severity='info'>No place history to show</Alert>}
            {!!list.hasResults && 
                <CustomList>
                {list.results.map((item, _idx) =>
                    <SearchPlacesListItem key={item.id} item={item} onView={props.onView}/>
                )}
                </CustomList>
            }

        </AsyncStatus>
    );
};

export default RecentPlacesList;